import React, { useContext } from "react";
import jpg1 from "../../assets/images/banner/1.jpg";
import { LanguageContext } from "../../context/LanguageContext";
import translations from "../../data/langData";
import { NavLink } from "react-router-dom";
import banneraz from "../../assets/images/logo/banneraz.jpg";
import LazyLoad from "react-lazy-load";

import slider1 from "../../assets/images/slider1.jpg";
import slider2 from "../../assets/images/slider2.jpg";
import slider3 from "../../assets/images/slider3.webp";

import slidervideo1 from "../../assets/images/slidervideo1.mp4";
import slidervideo2 from "../../assets/images/slidervideo2.mp4";

import slidervideo3 from "../../assets/images/slidervideo3.mp4";

import { Swiper, SwiperSlide } from "swiper/react";
import { Navigation, EffectFade ,Autoplay } from "swiper/modules"; // Navigation modulunu əlavə et
import "swiper/css";
import "swiper/css/navigation";
import 'swiper/css/effect-fade';
const ExploreAllCars = () => {
  const { language } = useContext(LanguageContext);
  const t = translations[language];
  return (
    <>
      <Swiper
        spaceBetween={20}
        pagination={{ clickable: true }}
        navigation={true}
        fadeEffect={{ crossFade: true }} 
        // autoplay={{
        //   delay: 3000,       
        //   disableOnInteraction: false, 
        // }}
        effect="fade"
        modules={[Navigation, EffectFade]}
        className="mySwiper"
      >
         <SwiperSlide>
         <div className="sliderBox">
            <video
              src={slidervideo3}
              autoPlay
              loop
              muted
              className="video w-100"
              style={{width:"100%",height:"650px",objectFit:"cover"}}
              // style={{ display: activeIndex === 0 ? 'block' : 'none' }} 
            ></video>
            <div className="sliderText">
                <h1>CHANGAN QIYUAN Q07</h1>
                <NavLink to="/changan" style={{textDecoration:"none"}}>
                  <button style={{width:"40%"}}> {t.viewdetails}</button>
                </NavLink>
              </div>
          </div>
        </SwiperSlide>
         <SwiperSlide>
         <div className="sliderBox">
            <video
              src={slidervideo1}
              autoPlay
              loop
              muted
              className="video w-100"
              style={{width:"100%",height:"650px",objectFit:"cover"}}
              // style={{ display: activeIndex === 0 ? 'block' : 'none' }} 
            ></video>
            <div className="sliderText">
                <h1>ZEEKR 7X</h1>
                <NavLink to="/zeekr" style={{textDecoration:"none"}}>
                  <button style={{width:"80%"}}> {t.viewdetails}</button>
                </NavLink>
              </div>
          </div>
        </SwiperSlide>
         <SwiperSlide>
         <div className="sliderBox">
            <video
              src={slidervideo2}
              autoPlay
              loop
              muted
              className="video w-100"
              style={{width:"100%",height:"650px",objectFit:"cover"}}
              // style={{ display: activeIndex === 0 ? 'block' : 'none' }} 
            ></video>
            <div className="sliderText">
                <h1>BYD Leopard 5</h1>
                <NavLink to="/li-auto" style={{textDecoration:"none"}}>
                  <button className="w-50"> {t.viewdetails}</button>
                </NavLink>
              </div>
          </div>
        </SwiperSlide>
        <SwiperSlide>
          <LazyLoad>
            <div className="sliderBox">
              <img
                src={slider1}
                alt=""
                className="img-fluid mb-5"
                loading="lazy"
                style={{ height: "650px", objectFit: "cover" }}
              />
              <div className="sliderText">
                <h1>Li Auto L7</h1>
                <p>{t.sliderImg}</p>
                <NavLink to="/li-auto" style={{textDecoration:"none"}}>
                  <button>{t.viewdetails}</button>
                </NavLink>
              </div>
            </div>
          </LazyLoad>
        </SwiperSlide>
        <SwiperSlide>
          <LazyLoad>
          <div className="sliderBox1">
              <img
                src={slider2}
                alt=""
                className="img-fluid mb-5"
                loading="lazy"
                style={{ height: "650px", objectFit: "cover" }}
              />
              <div className="sliderText1">
                <h1>Li Auto L9</h1>
                <p>{t.sliderImg1}</p>
                <NavLink to="/li-auto" style={{textDecoration:"none"}}>
                  <button>{t.viewdetails}</button>
                </NavLink>
              </div>
            </div>
          </LazyLoad>
        </SwiperSlide>
      </Swiper>

      {/* <section className="exploreallcars">
        <div class="widget-explore-car">
          <div class="themesflat-container">
            <div class="explore-car-wrap">
              <div class="header-section-main mb-46">
                <h2 class="title-section-main" style={{ fontWeight: "bold" }}>
                  {t.explorecars}
                </h2>
                <div class="btn-read-more me-2">
                  <NavLink to="/product" style={{ textDecoration: "none" }}>
                    <a class="more-link" style={{ textDecoration: "none" }}>
                      <span>{t.viewdetails}</span>
                      <i class="icon-arrow-up-right2"></i>
                    </a>
                  </NavLink>
                </div>
              </div>
              <div class="explore-car">
                <a href="#" class="explore-car-item">
                  <img src="assets/images/banner/1.jpg" alt="" />
                  <h5 class="title-explore">Sedan</h5>
                </a>
                <a href="#" class="explore-car-item">
                  <img src="assets/images/banner/2.jpg" alt="" />
                  <h5 class="title-explore">SUV</h5>
                </a>
                <a href="#" class="explore-car-item">
                  <img src="assets/images/banner/3.jpg" alt="" />
                  <h5 class="title-explore">Hatchback</h5>
                </a>
                <a href="#" class="explore-car-item">
                  <img src="assets/images/banner/4.jpg" alt="" />
                  <h5 class="title-explore">Hybrid</h5>
                </a>
                <a href="#" class="explore-car-item">
                  <img src="assets/images/banner/5.jpg" alt="" />
                  <h5 class="title-explore">Coupe</h5>
                </a>
              </div>
            </div>
          </div>
        </div>
      </section> */}
    </>
  );
};

export default ExploreAllCars;
